var map = {
	"../admin-query/admin-query.module": [
		"./src/app/admin-query/admin-query.module.ts",
		"admin-query.module",
		"common"
	],
	"../cli-order/cli-order.module": [
		"./src/app/cli-order/cli-order.module.ts",
		"cli-order.module"
	],
	"../coming-soon-abenergie/coming-soon.module": [
		"./src/app/coming-soon-abenergie/coming-soon.module.ts",
		"coming-soon.module.1"
	],
	"../coming-soon-fin/coming-soon.module": [
		"./src/app/coming-soon-fin/coming-soon.module.ts",
		"coming-soon.module.0"
	],
	"../coming-soon-noleggio/coming-soon.module": [
		"./src/app/coming-soon-noleggio/coming-soon.module.ts",
		"coming-soon.module"
	],
	"../details-drop/details-drop.module": [
		"./src/app/details-drop/details-drop.module.ts",
		"common",
		"details-drop.module"
	],
	"../details-ricond/details-ricond.module": [
		"./src/app/details-ricond/details-ricond.module.ts",
		"common",
		"details-ricond.module"
	],
	"../details/details.module": [
		"./src/app/details/details.module.ts",
		"common",
		"details.module"
	],
	"../dropshipping/dropshipping.module": [
		"./src/app/dropshipping/dropshipping.module.ts",
		"dropshipping.module",
		"common"
	],
	"../financing/financing.module": [
		"./src/app/financing/financing.module.ts",
		"financing.module",
		"common"
	],
	"../kasko-new/kasko-new.module": [
		"./src/app/kasko-new/kasko-new.module.ts",
		"kasko-new.module",
		"common"
	],
	"../kasko-rate-new/kasko-new-rate.module": [
		"./src/app/kasko-rate-new/kasko-new-rate.module.ts",
		"kasko-new-rate.module",
		"common"
	],
	"../kasko/kasko.module": [
		"./src/app/kasko/kasko.module.ts",
		"common",
		"kasko.module"
	],
	"../order-hist/order-hist.module": [
		"./src/app/order-hist/order-hist.module.ts",
		"order-hist.module"
	],
	"../order-history/order-history.module": [
		"./src/app/order-history/order-history.module.ts",
		"order-history.module"
	],
	"../order-new/order-new.module": [
		"./src/app/order-new/order-new.module.ts",
		"order-new.module",
		"common"
	],
	"../order-search/order-search.module": [
		"./src/app/order-search/order-search.module.ts",
		"order-search.module"
	],
	"../order/order.module": [
		"./src/app/order/order.module.ts",
		"common",
		"order.module"
	],
	"../orders-in-progress/orders-in-progress.module": [
		"./src/app/orders-in-progress/orders-in-progress.module.ts",
		"orders-in-progress.module"
	],
	"../ricondizionato/ricondizionato.module": [
		"./src/app/ricondizionato/ricondizionato.module.ts",
		"ricondizionato.module",
		"common"
	],
	"../shipment-daily/shipment-daily.module": [
		"./src/app/shipment-daily/shipment-daily.module.ts",
		"common",
		"shipment-daily.module"
	],
	"../shipment-hist/shipment-hist.module": [
		"./src/app/shipment-hist/shipment-hist.module.ts",
		"common",
		"shipment-hist.module"
	],
	"../shipment-in-progress/shipment-in-progress.module": [
		"./src/app/shipment-in-progress/shipment-in-progress.module.ts",
		"common",
		"shipment-in-progress.module"
	],
	"../shipment-new/shipment-new.module": [
		"./src/app/shipment-new/shipment-new.module.ts",
		"shipment-new.module",
		"common"
	],
	"../shipment/shipment.module": [
		"./src/app/shipment/shipment.module.ts",
		"common",
		"shipment.module"
	],
	"../transaction/transaction.module": [
		"./src/app/transaction/transaction.module.ts",
		"transaction.module"
	],
	"../vendite-drop/vendite-drop.module": [
		"./src/app/vendite-drop/vendite-drop.module.ts",
		"common",
		"vendite-drop.module"
	],
	"../vendite-ricond/vendite-ricond.module": [
		"./src/app/vendite-ricond/vendite-ricond.module.ts",
		"common",
		"vendite-ricond.module"
	],
	"./ecommerce/ecommerce.module": [
		"./src/app/ecommerce/ecommerce.module.ts",
		"ecommerce.module",
		"common"
	],
	"./panel-admin/panel-admin.module": [
		"./src/app/panel-admin/panel-admin.module.ts",
		"common",
		"panel-admin.module"
	],
	"./panel-agent/panel-agent.module": [
		"./src/app/panel-agent/panel-agent.module.ts",
		"common",
		"panel-agent.module"
	],
	"./panel-cli/panel-cli.module": [
		"./src/app/panel-cli/panel-cli.module.ts",
		"common",
		"panel-cli.module"
	],
	"./panel-covercare/panel-covercare.module": [
		"./src/app/panel-covercare/panel-covercare.module.ts",
		"common",
		"panel-covercare.module"
	],
	"./panel-lab/panel-lab.module": [
		"./src/app/panel-lab/panel-lab.module.ts",
		"common",
		"panel-lab.module"
	],
	"./panel-shop/panel-shop.module": [
		"./src/app/panel-shop/panel-shop.module.ts",
		"common",
		"panel-shop.module"
	],
	"./shop-master/shop-master.module": [
		"./src/app/shop-master/shop-master.module.ts",
		"common",
		"shop-master.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main